// MapboxContext.js
import React, { createContext, useContext } from "react";
import mapboxgl from "mapbox-gl";

// Create a context for Mapbox
const MapboxContext = createContext();

// Custom hook to access the Mapbox context
export const useMapbox = () => useContext(MapboxContext);

// Provider component to wrap your app
export const MapboxProvider = ({ children }) => {
  // Initialize Mapbox with your access token
  mapboxgl.accessToken = "pk.eyJ1IjoiemFtcCIsImEiOiJjbTkxa3dkcnMwMmQxMnJzYzBobW9hOHBiIn0.GWvvqPrWqtMby0HYCYdjMQ";

  return (
    <MapboxContext.Provider value={{ mapboxgl }}>
      {children}
    </MapboxContext.Provider>
  );
};